<template>
  <Card>
    <template v-slot:title>
      <Skeleton width="50%" height="25px" />
    </template>
    <template v-slot:content>
      <div class="p-grid p-mt-4">
        <div class="p-col-12" v-for="index in rows" :key="index">
          <Skeleton width="100%" height="30px" class="p-mb-4" />
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
export default {
  name: 'AppSkeletonCardForm',
  props: {
    rows: {
      type: Number,
      default: 6
    }
  }
};
</script>

<style>
</style>